import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { default as PaginationRC } from 'rc-pagination';

import { isBrowser, Nullable } from '@tager/web-core';

import Icon from '@/assets/svg/NextArrow.svg';
import { colors } from '@/constants/theme';

type Props = {
  pageSize: number;
  onChange: (current: number) => void;
  count?: number;
  current: number;
  className?: string;
};

function Pagination({ onChange, count, pageSize, current, className }: Props) {
  const [offSetTop, setOffsetTop] = useState<number>(0);
  const [offSetTopClient, setOffsetTopClient] = useState<number>(0);

  const ref = useRef<HTMLDivElement>(null);

  const onPageChange = (page: number) => {
    if (ref.current) {
      setOffsetTop(ref.current.offsetTop);
      setOffsetTopClient(ref.current.getBoundingClientRect().top);
    }
    onChange(page);
  };

  useEffect(() => {
    const domNode = ref.current;
    if (!domNode) {
      return;
    }
    if (offSetTop === 0) {
      return;
    }
    const nodeOffsetTopCurrent = domNode.offsetTop;
    if (nodeOffsetTopCurrent !== offSetTop) {
      isBrowser() &&
        window.scroll({
          top:
            domNode.offsetTop -
            (domNode.getBoundingClientRect().height + offSetTopClient - 40),
        });
    }
  });

  useEffect(() => {
    if (ref.current) {
      ref.current
        .querySelector('.rc-pagination-next')
        ?.setAttribute('title', '');
      ref.current
        .querySelector('.rc-pagination-prev')
        ?.setAttribute('title', '');
    }
  }, []);

  return (
    <Component ref={ref} className={className}>
      <PaginationRC
        className="pagination"
        nextIcon={true}
        current={current}
        hideOnSinglePage
        pageSize={pageSize}
        onChange={onPageChange}
        showSizeChanger={false}
        total={count}
        showLessItems
      />
    </Component>
  );
}

export default Pagination;

const Component = styled.div`
  padding: 5px 0;
  .rc-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    & > li:not(:first-child) {
      margin-left: 10px;
    }
  }

  .rc-pagination-prev,
  .rc-pagination-next,
  .rc-pagination-item {
    position: relative;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid ${colors.gray70};
  }

  .rc-pagination-prev:after {
    content: url(${Icon});
    position: absolute;
    left: calc(50% + 1px);
    top: calc(50% - 1px);
    transform: translate(-50%, -50%) rotate(180deg);
  }

  .rc-pagination-next:after {
    content: url(${Icon});
    position: absolute;
    left: 50%;
    top: calc(50% + 1px);
    transform: translate(-50%, -50%);
  }

  .rc-pagination-item {
    color: ${colors.black};
    border-radius: 5px;
  }

  .rc-pagination-disabled {
    border: 1px solid ${colors.gray100};
  }

  .rc-pagination-item-active {
    background: ${colors.primary};
    color: ${colors.white};
  }

  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    display: none;
  }
`;
